export default "__VITE_ASSET__377d7c7b__"